<template>
  <div class="contact-view">
    <!-- Hero -->
    <section class="hero">
      <div class="container">
        <h1 class="hero-title">실제 도메인 연결이 필요합니다.</h1>
        <p class="hero-subtitle">연결 후 지도에 모든 공고가 보입니다.</p>
      </div>
    </section>
     </div>
</template>